import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TestCenterDashboard from './pages/TestCenterDashboard';
import InvigilatorDashboard from './pages/InvigilatorDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import UserList from './pages/users/UserList';
import AddUser from './pages/users/AddUser';
import ScheduleList from './pages/schedules/ScheduleList';
import AddSchedule from './pages/schedules/AddSchedule';
import ScheduleDetail from './pages/schedules/ScheduleDetail';
import ShiftList from './pages/shifts/ShiftList';
import AddShift from './pages/shifts/AddShift';
import InvigilatorMapping from './pages/invigilators/InvigilatorMapping';
import AttendanceMarking from './pages/invigilators/AttendanceMarking';
import RemunerationCalculator from './pages/remuneration/RemunerationCalculator';
import RemunerationSummary from './pages/remuneration/RemunerationSummary';
import ReportGeneration from './pages/reports/ReportGeneration';
import Navbar from './components/Navbar';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';

const AppLayout = () => {
  const location = useLocation();
  const isPublic = location.pathname === '/login';

  return (
    <>
      {!isPublic && <Navbar />}
      <div style={!isPublic ? { paddingTop: '64px' } : {}}>
        <Routes>

          {/* PUBLIC */}
          <Route path="/login" element={<Login />} />

          {/* SHARED — all logged-in roles can access profile & change-password */}
          <Route
            element={
              <ProtectedRoute
                allowedRoles={['super_admin', 'system_admin', 'tca', 'invigilator', 'attender']}
              />
            }
          >
            <Route path="/profile"         element={<Profile />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>

          {/* SUPER ADMIN + SYSTEM ADMIN */}
          <Route
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'system_admin']} />
            }
          >
            <Route path="/dashboard"            element={<Dashboard />} />
            <Route path="/users"                element={<UserList />} />
            <Route path="/users/add"            element={<AddUser />} />
            <Route path="/users/edit/:id"       element={<AddUser />} />
            <Route path="/remuneration/summary" element={<RemunerationSummary />} />
            <Route path="/reports"              element={<ReportGeneration />} />
          </Route>

          {/* SUPER ADMIN + TCA + SYSTEM ADMIN */}
          <Route
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'tca', 'system_admin']} />
            }
          >
            <Route path="/test-center"              element={<TestCenterDashboard />} />
            <Route path="/schedules"                element={<ScheduleList />} />
            <Route path="/schedules/add"            element={<AddSchedule />} />
            <Route path="/schedules/:id"            element={<ScheduleDetail />} />
            <Route path="/shifts"                   element={<ShiftList />} />
            <Route path="/shifts/add"               element={<AddShift />} />
            <Route path="/shifts/:id/mapping"       element={<InvigilatorMapping />} />
            <Route path="/shifts/:id/attendance"    element={<AttendanceMarking />} />
            <Route path="/remuneration/:scheduleId" element={<RemunerationCalculator />} />
          </Route>

          {/* INVIGILATOR */}
          <Route
            element={
              <ProtectedRoute allowedRoles={['invigilator']} />
            }
          >
            <Route path="/invigilator"     element={<InvigilatorDashboard />} />
            <Route path="/my-shifts"       element={<ShiftList />} />
            <Route path="/my-schedule/:id" element={<ScheduleDetail />} />
            <Route path="/my-remuneration" element={<RemunerationSummary />} />
          </Route>

          {/* ATTENDER */}
          <Route
            element={
              <ProtectedRoute allowedRoles={['attender']} />
            }
          >
            <Route path="/attender" element={<InvigilatorDashboard />} />
          </Route>

          {/* FALLBACK */}
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/login" />} />

        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} />
        <AppLayout />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;